import { get } from 'core/helpers/fetch';

export default function fetchUsers() {
  return get('/users');
}
